import React, { useState, useEffect, useRef } from "react";
import "../PopularTest/styles.scss";
import {
  Card,
  CardSelectTest,
  CardSelectedTest,
  MobileCardSelectedTest,
  SliderComponent,
} from "../../components";
import { useSelector } from "react-redux";
import dropdown1 from "../../assets/images/dropdown.svg";
import { Modal } from "react-bootstrap";
import { Popup, Filter } from "../../components";
import Layout from "../../layout";
import Search from "../../assets/images/search.svg";
import idea from "../../assets/images/idea1.svg";
import logos1 from "../../assets/images/logos1.svg";
import logos2 from "../../assets/images/logos2.svg";
import ficon from "../../assets/images/popularS.svg";
import logos4 from "../../assets/images/logos4.svg";
import logos5 from "../../assets/images/logos5.svg";
import ArrowLeft from "../../assets/images/Arrow-left.svg";
import One from "../../assets/images/one.svg";
import Two from "../../assets/images/two.svg";
import Three from "../../assets/images/three.svg";
import Chat from "../../components/Chat/Chat";
import home from "../../assets/images/HomeDisable.svg";
import rightArr from "../../assets/images/navRight.svg";
import doctall from "../../assets/images/doctall.svg";
import axios from "../../redux/axios";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import {
  testValue,
  removeTest,
  featureRemoveTest,
  clearTest,
  clearSearch,
  areaValue,
  login,
} from "../../redux/auth/actions";
import left from "../../assets/images/left.svg";
import right from "../../assets/images/right.svg";
import Backicon from "../../assets/images/mobback.svg";
import Stepone from "../../assets/images/stepone.svg";
import Steptwo from "../../assets/images/steptwo.svg";
import Sheet from "react-modal-sheet";
import {
  getRecommendedTest,
  getCities,
  getPartners,
  doEncryption,
} from "./services/recommendedTestsServices";

export default function RecommendedTestPage(props) {
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  const cityState = useSelector((state) =>
    state.city != undefined && state.city.label != undefined ? state.city : ""
  );
  const areaState = useSelector((state) =>
    state.area != undefined && state.area.area != undefined
      ? state.area.area
      : ""
  );

  const [ShowLocation, setShowLocation] = useState(false);
  const [selectedRec, setSelectedRec] = useState([]);
  const [update, setUpdate] = useState(false);
  const [ShowArea, setShowArea] = useState(false);
  const [rangeFilter, setRangFilter] = useState("A-Z");
  const [arrIndex, setArrIndex] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [testData, setTestData] = useState([]);
  const [filterValue, setFilterValue] = useState("pathology");
  const [inputSearch, setInputSearch] = useState("");
  const [btn, setBtn] = useState(false);
  const [btmLocationSheet, setbtmLocationSheet] = useState(false);
  const cities = useSelector((state) => state.auth.cities);
  const [testListing, setTestListing] = useState([]);
  const [allTestRange, setAllTestRange] = useState("A-Z");
  const [count, setCount] = useState(0);
  const [locPop, setLocPop] = useState(false);
  const [pageno, setPageno] = useState(0);
  const [partner, setPartner] = useState([]);
  const [area, setArea] = useState("");
  const [mobileView, setMobileView] = useState(false);
  const [mobileTestpopstate, setMobiletestpopstate] = useState(false);
  const dispatch = useDispatch();
  const [areaId, setAreaId] = useState("");
  const sheetRef = useRef();
  const [btmSheet, setbtmSheet] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [noDataError, setNoDataError] = useState(false);
  const [encryptedData, setEncryptedData] = useState();
  const [adviceId, setAdviceId] = useState();
  const globalSearch = useSelector((state) => state.auth.search);
  const test = useSelector((state) => state);
  const history = useHistory();
  const lanTestes = history.location.state;
  const arealocal = useSelector((state) => state.area);

  const [recPartnerUuid, setrecPartnerUuid] = useState("");
  useEffect(() => {
    window.scrollTo(0, 400);
    fetchPartners();
  }, []);

  useEffect(() => {
    try {
      dispatch(clearTest());
      setShowLocation(true);
      scrollUp();
      setTestData([]);
      let data = onStart();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    try {
      fetchRecommendedTest(
        encryptedData && encryptedData,
        arealocal.area.value
      );
    } catch (error) {
      console.log(error);
    }
  }, [arealocal]);

  const onStart = async () => {
    try {
      let data = await doEncryption(props.match.params.id);
      console.log(data, "datadata");
      // data.map((item) => {
      //  return setrecPartnerUuid(data[0].labAdvice[0].recomended_partner_name)
      // })
      setrecPartnerUuid(data[0].labAdvice[0].recomended_partner_name);
      console.log(recPartnerUuid, "datadata");
      // setrecPartnerUuid(data[0].recomended_partner_name);
      let credential = data && data[0].loginDetails;
      const username = credential.userName;
      const password = credential.password;
      let payLoad = {
        username,
        password,
      };
      dispatch(
        login(payLoad, (res) => {
          localStorage.setItem("PWD", password);
          localStorage.setItem("CTKN", res.token);
        })
      );

      setEncryptedData(data && data[0].labAdvice);
      fetchRecommendedTest(data && data[0].labAdvice, arealocal.area.value);

      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRecommendedTest = async (testId, areaId) => {
    try {
      let response = await getRecommendedTest(testId, areaId);
      if (response.data.length > 0) {
        localStorage.setItem("ADVICE_ID", testId[0].advice_id);
        setTestData(response.data);
        setNoDataError(false);
        console.log(response.data);
      } else {
        setTestData([]);
        setNoDataError(true);
      }
    } catch (error) {
      setTestData([]);
      setNoDataError(true);
    }
  };

  const fetchPartners = async () => {
    try {
      let response = await getPartners();
      setPartner(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (areaState.value === undefined) {
      setAreaId("");
    } else {
      setAreaId(areaState.value);
    }
  }, [areaState]);

  const handleLocPop = () => {
    ShowLocation === true ? setShowLocation(false) : setShowLocation(true);
  };

  const selectTest = (i, value) => {
    if (arealocal.area.value === "") {
      dispatch(clearTest());

      setShowLocation(true);
    } else {
      selectedRec.push(value);
      dispatch(testValue(value));
      arrIndex.push(i);
      setUpdate(!update);
    }
  };
  const scrollUp = () => {
    setTimeout(() => window.scrollTo(0, 200), 1);
  };
  const delSelectedTest = (v) => {
    dispatch(removeTest(v.doc.uuid));
  };

  const handlleRemoveTest = (v) => {
    dispatch(featureRemoveTest(v.uuid));
  };

  const handleLocationClose = () => {
    setShowLocation(false);
  };

  const handleAreaClose = () => {
    setShowArea(false);
  };

  useEffect(() => {
    if (lanTestes) {
      let data = selectedRec.concat(lanTestes);
      setSelectedRec(data);
      setUpdate(!update);
    }
  }, []);

  const handleCount = (v) => {
    const result = count + v;
    setTestListing([]);
    if (result > 0) {
      setCount(result);
    } else {
      setCount(0);
    }
  };

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 600
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);
  const handlemobileTestpop = () => {
    setMobiletestpopstate(false);
  };

  return (
    <>
      <Layout>
        <div className="popularContainer">
          {!mobileView ? (
            <>
              <div className="title">
                <img
                  src={home}
                  alt="icon"
                  onClick={() => {
                    history.push("/");
                  }}
                />
                <img src={rightArr} alt="icon" />
                Recommended Tests
              </div>
              <div className="steps_to_follow">
                <div className="header">RECOMMENDED TEST</div>
              </div>
            </>
          ) : (
            <div className="mobile-view-popular-outer-cls">
              <div
                className="header-back-row"
                onClick={() => {
                  history.goBack();
                }}
              >
                <img src={Backicon} alt="Backicon" />
                <div className="back-text">Back</div>
              </div>
            </div>
          )}
          <div className="page_container">
            <div className="input_containerrr">
              <div className="leftContainer">
                <div className="heading_container">
                  <div className="heading"></div>
                  <div className="txt">
                    {/* Browse through our common/popular tests */}
                  </div>
                </div>
                <div className="filter_container"></div>
              </div>
              {!mobileView && (
                <div className="right_container">
                  <span>Set Location</span>
                  {cityState.label !== "" && areaState.label !== "" ? (
                    <div
                      className="location"
                      onClick={() => {
                        window.scrollTo(0, 400);
                        setShowLocation(true);
                      }}
                    >
                      City: {cityState.label} Area: {areaState.label}
                    </div>
                  ) : (
                    <div
                      className="location"
                      onClick={() => setShowLocation(true)}
                    >
                      Search and set your location
                      <img src={dropdown1} alt="icon" />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="Card_container_list">
              {noDataError && (
                <h5>No Tests Found For The Saved/Selected Location !</h5>
              )}

              <div className="pathologyCardList">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexFlow: "wrap",
                    width: "100%",
                    gap: "12px",
                  }}
                >
                  {testData.length !== 0
                    ? testData.map((value, i) => (
                        <CardSelectTest
                          recPartnerUuid={recPartnerUuid}
                          index={i}
                          key={i}
                          val={value}
                          heading={value.doc.standardisedtestname}
                          subHeading={value.doc.partnerstestname}
                          des={value.doc.populartestdescription}
                          handleItems={selectTest}
                          handleItemDelete={delSelectedTest}
                          recommendedTest={true}
                        />
                      ))
                    : ""}
                </div>

                {showCard ? (
                  <>
                    {" "}
                    {testListing && testListing.length !== 0
                      ? testListing.data.map((value, i) => (
                          <CardSelectTest
                            recPartnerUuid={recPartnerUuid}
                            index={i}
                            key={i}
                            val={value}
                            heading={value.doc.standardisedtestname}
                            subHeading={value.doc.partnerstestname}
                            des={value.doc.populartestdescription}
                            handleItems={selectTest}
                            handleItemDelete={delSelectedTest}
                            recommendedTest={true}
                          />
                        ))
                      : ""}
                  </>
                ) : (
                  ""
                )}
                <div className="pagination_container">
                  {showCard && (
                    <div className="page_container">
                      <div className="left_btn" onClick={() => handleCount(-1)}>
                        <img src={left} alt="icon" />
                      </div>
                      <div className="no_container">
                        Page <span>{count}..</span> of{" "}
                        {testListing && testListing.count !== undefined
                          ? testListing.count
                          : ""}
                      </div>
                      <div className="right_btn" onClick={() => handleCount(1)}>
                        <img src={right} alt="icon" />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {(!mobileView && (
                <CardSelectedTest
                  type="popular_test"
                  list={selectedRec}
                  del={delSelectedTest}
                  featuredel={handlleRemoveTest}
                  area={area}
                  handleLocPop={handleLocPop}
                  recommendedTest={true}
                  recPartnerUuid={recPartnerUuid}
                />
              )) ||
                ""}
            </div>
          </div>
        </div>
        {(!mobileView && (
          <div className="container_work">
            <div className="heading">How it works?</div>
            <div className="text">Get your medical tests in 3-simple steps</div>
            <Card />
          </div>
        )) ||
          ""}
        <SliderComponent />
        {(!mobileView && (
          <div className="trustpar">
            <div className="by">
              OUR PARTNERS
            </div>
            <div className="imgc">
              {/* Need to style the images, */}
              {partner &&
                partner.map((partner) => (
                  <div>
                    <img
                      style={{ height: "20px", width: "45px" }}
                      src={partner.logo}
                      alt="icon"
                    />
                  </div>
                ))}
            </div>
          </div>
        )) ||
          ""}
        <Sheet
          isOpen={btmSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <MobileCardSelectedTest
                type="popular_test"
                onClose={() => {
                  setbtmSheet(false);
                }}
                list={selectedRec}
                del={delSelectedTest}
                featuredel={handlleRemoveTest}
                area={area}
                recommendedTest={true}
                recPartnerUuid={recPartnerUuid}
                handleLocPop={handleLocPop}
              />{" "}
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
        <Sheet
          isOpen={btmLocationSheet}
          snapPoints={[600, 400, 100, 0]}
          onClose={() => setbtmLocationSheet(false)}
        >
          <Sheet.Container>
            <Sheet.Header />
            <Sheet.Content>
              <Popup
                city={cities}
                setShowLocation={() => {
                  setbtmLocationSheet(false);
                  setbtmSheet(true);
                }}
                setArea={setArea}
                setSelectedRec={setSelectedRec}
              />{" "}
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
        {(mobileView && (
          <FloatingIcon
            onClick={() => {
              area.length == 0 ? setbtmLocationSheet(true) : setbtmSheet(true);
            }}
            count={selectedRec.length}
          />
        )) ||
          ""}
        <Modal show={ShowArea} onHide={handleAreaClose}>
          <Filter />
        </Modal>
        <Modal show={ShowLocation} onHide={handleLocationClose}>
          <Popup
            city={cities}
            setShowLocation={setShowLocation}
            setArea={setArea}
            setSelectedRec={setSelectedRec}
          />
        </Modal>
        <Modal show={mobileTestpopstate} onHide={handlemobileTestpop}>
          <Popup
            city={cities}
            setShowLocation={setShowLocation}
            setArea={setArea}
          />
        </Modal>
        {/* <Chat /> */}
      </Layout>
    </>
  );
}
const FloatingIcon = (props) => {
  return (
    <div className="floatingIcon" onClick={() => props.onClick()}>
      <div className="count">{props.count}</div>
      <img src={ficon} />
      {(props.count == 0 && <div className="foverlay"></div>) || ""}
    </div>
  );
};
